__turbopack_context__.v({
  "copied": "fakeNameGenerator-module___5Tjuq__copied",
  "copyAllBtn": "fakeNameGenerator-module___5Tjuq__copyAllBtn",
  "copyBtn": "fakeNameGenerator-module___5Tjuq__copyBtn",
  "downloadBtn": "fakeNameGenerator-module___5Tjuq__downloadBtn",
  "downloadLabel": "fakeNameGenerator-module___5Tjuq__downloadLabel",
  "extraItem": "fakeNameGenerator-module___5Tjuq__extraItem",
  "extrasRow": "fakeNameGenerator-module___5Tjuq__extrasRow",
  "generateBtn": "fakeNameGenerator-module___5Tjuq__generateBtn",
  "nameItem": "fakeNameGenerator-module___5Tjuq__nameItem",
  "nameItemContent": "fakeNameGenerator-module___5Tjuq__nameItemContent",
  "nameItemExtras": "fakeNameGenerator-module___5Tjuq__nameItemExtras",
  "nameItemName": "fakeNameGenerator-module___5Tjuq__nameItemName",
  "nameList": "fakeNameGenerator-module___5Tjuq__nameList",
  "optionGroup": "fakeNameGenerator-module___5Tjuq__optionGroup",
  "optionGroupCheck": "fakeNameGenerator-module___5Tjuq__optionGroupCheck",
  "optionsRow": "fakeNameGenerator-module___5Tjuq__optionsRow",
  "resultActions": "fakeNameGenerator-module___5Tjuq__resultActions",
  "resultCard": "fakeNameGenerator-module___5Tjuq__resultCard",
  "resultHeader": "fakeNameGenerator-module___5Tjuq__resultHeader",
  "resultTitle": "fakeNameGenerator-module___5Tjuq__resultTitle",
  "singleName": "fakeNameGenerator-module___5Tjuq__singleName",
  "singleResult": "fakeNameGenerator-module___5Tjuq__singleResult",
  "singleRow": "fakeNameGenerator-module___5Tjuq__singleRow",
  "wrapper": "fakeNameGenerator-module___5Tjuq__wrapper",
});
